import React, { useState, useEffect, use, useMemo } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  Box,
  Tab,
  Tabs,
  Card,
  Grid,
  Select,
  Divider,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  Button,
  Tooltip,
  Chip,
  IconButton,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Refresh } from "@material-ui/icons";

import { getAllDepartments } from "../../reducer/department/action";
import { recalculateResearchHours } from "../../reducer/timeResearchInformation/action";

import toJs from "../../hoc/toJS";
import select from "../../utils/select";
import TimeResearchTable from "../../containers/Report/TimeResearchTable/TimeResearchTable";
import ReviewContractTable from "../../containers/Report/ReviewContractTable/ReviewContractTable";
import ContractRewardTable from "../../containers/Report/ContractRewardTable/ContractRewardTable";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";

// const getCurrentYear = () => parseInt(moment().format("YYYY"));

function Report(props) {
  const [tab, setTab] = useState(0);
  const [department, setDepartment] = useState([0]);
  const [calAgain, setCalAgain] = useState(false);

  // Get current year's start and end dates (fiscal year: April 1st to March 31st)
  const currentYear = new Date().getFullYear();
  const [startDate, setStartDate] = useState(`${currentYear - 1}-04-01`);
  const [endDate, setEndDate] = useState(`${currentYear}-03-31`);

  useEffect(() => {
    if (props.departments.length === 0) props.getAllDepartments();
  }, [props.getAllDepartments, props.departments.length]);

  const handleChangeTab = (_, value) => setTab(value);

  const handleChangeDepartment = (event) => {
    const newValue = event.target.value;
    // console.log("Selected department:", newValue);
    // nếu newValue có giá trị 0 ở cuối thì chỉ giữ lại 0
    if (newValue.includes(0) && newValue.indexOf(0) === newValue.length - 1) {
      setDepartment([0]);
      return;
    }

    // delete 0 in newValue
    if (newValue.includes(0)) {
      if (newValue.length > 1) newValue.splice(newValue.indexOf(0), 1);
    }
    setDepartment(newValue);
  };

  const renderTab = () => {
    switch (tab) {
      case 0:
        return (
          <TimeResearchTable calAgain={calAgain} startDate={startDate} endDate={endDate} department={department} />
        );
      // case 1:
      //   return <ContractRewardTable year={year} department={department}/>
      // case 2:
      //   return <ReviewContractTable year={year} department={department}/>
      default:
        return <div>Không tìm thấy trang này!</div>;
    }
  };

  const renderDepartment = () => {
    var departmentOptions = [];
    props.profileDepartments?.forEach((department) => {
      if (
        department.departmentProfile?.filter((item) => item?.profileId === props.profile?.id)[0]?.roleInDepartment ===
        "leader"
      )
        departmentOptions.push(department);
    });
    if (department === 0) setDepartment(departmentOptions[0]?.id);
    return departmentOptions.map((item) => {
      return (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      );
    });
  };

  const _departments = useMemo(() => {
    var dept = [];
    if (props.role === "sudo-admin") {
      dept = props.departments;
    } else {
      props.profileDepartments?.forEach((department) => {
        if (
          department.departmentProfile?.filter((item) => item?.profileId === props.profile?.id)[0]?.roleInDepartment ===
          "leader"
        )
          dept.push(department);
      });
      if (department === 0) {
        setDepartment(dept[0]?.id);
      }
    }
    return dept;
  }, [props.role]);

  return (
    <Card style={{ minHeight: "calc(100vh - 92px)", maxHeight: "calc(100vh - 92px)", position: "relative" }}>
      <Grid container justifyContent={"space-between"}>
        <Grid item xs={3}>
          <Tabs value={tab} scrollButtons="auto" variant="scrollable" textColor="secondary" onChange={handleChangeTab}>
            <Tab label="Báo cáo giờ nghiên cứu" />
            {/* <Tab label="Chốt hợp đồng" />
            <Tab label="Hợp đồng đến kỳ review" /> */}
          </Tabs>
        </Grid>
        <Grid item xs={9}>
          <Box
            style={{ float: "right", marginTop: 15, marginBottom: 7, display: "flex", gap: 8, alignItems: "center" }}
          >
            <TextField
              type="date"
              size="small"
              label="Ngày bắt đầu"
              variant="outlined"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              style={{ width: 160 }}
            />
            <TextField
              type="date"
              size="small"
              label="Ngày kết thúc"
              variant="outlined"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              style={{ width: 160 }}
            />
            {tab !== 3 && (
              <FormControl variant={"outlined"} size="small">
                <InputLabel>Đơn vị</InputLabel>
                <Select
                  label={"Đơn vị"}
                  value={department}
                  multiple
                  onChange={handleChangeDepartment}
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: { vertical: "bottom", horizontal: "center" },
                    transformOrigin: { vertical: "top", horizontal: "center" },
                  }}
                  SelectDisplayProps={{ style: { fontSize: 14, paddingTop: 8, paddingBottom: 8 } }}
                  renderValue={(selected) => {
                    const selectedLabels = selected
                      .map((value) => _departments.find((o) => o.id === value)?.name)
                      .filter(Boolean); // loại undefined nếu có
                    return (
                      <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {selectedLabels.length > 2
                          ? `${selectedLabels.slice(0, 2).join(", ")} +${selectedLabels.length - 2} khác`
                          : selectedLabels.join(", ")}
                      </Box>
                    );
                  }}
                >
                  {_departments.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                const success = await props.recalculateResearchHours(startDate, endDate);
                if (success) {
                  setCalAgain(!calAgain);
                }
              }}
            >
              Tính lại
            </Button>
            <Tooltip title="Tải lại dữ liệu">
              <Button
                color="primary"
                size="small"
                onClick={() => {
                  setCalAgain(!calAgain);
                }}
                style={{ border: "1px solid #3f51b5" }}
              >
                <Refresh />
              </Button>
            </Tooltip>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ margin: 8 }}>
        {renderTab()}
      </Grid>
    </Card>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  departments: select(state, "departmentReducer", "departments"),
  profileDepartments: select(state, "profileReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllDepartments: () => dispatch(getAllDepartments()),
  recalculateResearchHours: (startDate, endDate) => dispatch(recalculateResearchHours(startDate, endDate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(Report));

